/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Seat_Change_Cancel_Description_MinimumInputs */



/**
* | output |
* | --- |
* | "One empty {from} base seat stays {from} instead of becoming {to} at the renewal." |
*
* @param {Seat_Change_Cancel_Description_MinimumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_cancel_description_minimum = /** @type {((inputs: Seat_Change_Cancel_Description_MinimumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Cancel_Description_MinimumInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein freier ${i?.from}-Basisplatz bleibt ${i?.from} und wird zur Verlängerung nicht zu ${i?.to}.`)
	return /** @type {LocalizedString} */ (`One empty ${i?.from} base seat stays ${i?.from} instead of becoming ${i?.to} at the renewal.`)
});